import { Injectable } from '@angular/core';
import { ApiBaseService } from '../api-base.service';
import { BehaviorSubject } from 'rxjs';
import { Contract } from 'src/app/pages/contracts/contract-form/contract-form.component';
import { AppGlobals } from 'src/app/app.globals';

@Injectable({
  providedIn: 'root'
})
export class ContractSelectorService {

  private nonFrameworkContractsSubject = new BehaviorSubject<Contract[]>([]);
  nonFrameworkContracts$ = this.nonFrameworkContractsSubject.asObservable();

  private siteContractsSubject = new BehaviorSubject<Contract[]>([]);
  siteContracts$ = this.siteContractsSubject.asObservable();

  private contractTypesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  contractTypes$ = this.contractTypesSubject.asObservable();

  constructor(private apiBaseService: ApiBaseService) { }

  async getContracts(payload: any): Promise<any> {
    return this.apiBaseService
          .httpRequest("ContractService/GetContracts", payload, true, true)
          .then((response) => {
            this.nonFrameworkContractsSubject.next(
              response.contracts?.filter((contract) => !contract.isFrameworkContract)
            );
          })
          .catch((error) => {
            AppGlobals.ShowErrorMessage(error);
            this.nonFrameworkContractsSubject.next([]); // Emit an empty array on error
          });
  }

  async getContractTypes(payload: any): Promise<any> {
    return this.apiBaseService
      .httpRequest("ContractService/GetContractTypes", {}, true, false)
      .then((response) => {
        this.contractTypesSubject.next(response.contractTypes);
      })
      .catch((error) => {
        AppGlobals.ShowErrorMessage(error);
        this.contractTypesSubject.next([]);
      });
  }

  async getSiteContracts(payload: any): Promise<any> {
    return this.apiBaseService
          .httpRequest("ContractService/GetContracts", payload, true, true)
          .then((response) => {
            console.log('Site contracts response:', response);
            this.siteContractsSubject.next(response.contracts);
          })
          .catch((error) => {
            AppGlobals.ShowErrorMessage(error);
            this.siteContractsSubject.next([]); // Emit an empty array on error
          });
  }

  // Contracts linked to projects on the site (always project links, never site/property/task).
  async getProjectContractsBySite(payload: any): Promise<any> {
    return this.apiBaseService
          .httpRequest("ContractService/GetProjectContractsBySiteId", payload, true, true)
          .then((response) => {
            this.siteContractsSubject.next(response.contracts);
          })
          .catch((error) => {
            AppGlobals.ShowErrorMessage(error);
            this.siteContractsSubject.next([]); // Emit an empty array on error
          });
  }

  async addNewProjectToContracts(payload: any): Promise<any> {
    return this.apiBaseService
      .httpRequest("ContractService/AddNewProjectToContracts", payload, true, true)
      .then((response) => {
        console.log('Add project to contracts response:', response);
      })
      .catch((error) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }
}
